<template>
  <div><Scene></Scene></div>
</template>

<script>
import Scene from './components/Scene';

export default {
  name: 'App',

  components: {
    Scene,
  },
};
</script>

<style>
body,
html {
  padding: 0;
  margin: 0;
  overflow: hidden;
}

.form-control {
  position: relative;
}

.form-control::before {
  content: attr(data-label);
  position: absolute;
  right: 2px;
  bottom: 2px;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/App.vue